import { ApiStatus } from '../../types';

export const contractDefaultAEM =  {
    'heading': 'Contracts and legal stuff',
    'description': 'Make sure you read these documents before accepting them. Let us know if there\'s anything you don\'t understand.',
    'disclaimersHeading': 'By doing so, you:',
    'disclaimers': [
        'Consent to receiving your documents using the following links',
        'Understand you won’t receive a paper copy unless you request it',
    ],
    'checkBoxText': 'I\'ve read the documents above and agree to their terms.',
    'cancelButtonText': 'Cancel',
    'confirmButtonText': 'Accept',
    'validationMessage': 'Please visit all links and check box before submitting',
    'contractLinksHeading': 'Your InstalPay contract, Terms & Conditions',
    'documentsHeading': 'Other important documents',
    'pdfHeader': 'Your InstalPay contract',
    'popUpPage': {
        'heading': '<b>Sure you want to leave?</b>',
        'description': 'We\'ll take you to the Upowr checkout page where you can choose another payment option. /n The information you\'ve entered in this application won\'t be saved.',
        'returnButton': 'Return to InstalPay',
        'checkoutButton': 'Go to uPowr checkout',
    },
    'contractLinks': {
        'termsAndConditions': {
            'documentURL': 'https://www.commbank.com.au/personal/apply-online/download-printed-forms/ADB2911.pdf',
            'documentName': 'InstalPay Terms and Conditions (PDF,550kB)',
        },
        'privacyConsent': {
            'documentURL': 'https://www.commbank.com.au/personal/apply-online/download-printed-forms/TLS125_Online.pdf',
            'documentName': 'Privacy Consent (PDF,550kB)',
        },
    },
};

export type ContractAEM = typeof contractDefaultAEM;
export type ContractLink = {
  documentName: string;
  documentURL: string;
  documentSize?: string;
}

export interface ContractEndpoints {
  createContractUrl: string;
  acceptContractUrl?: string;
}

export interface AcceptContractRequest {
  applicationNumber: string;
  documentId: string;
  documentType: string;
}

export interface ConsentDetails {
  hasConsent: boolean;
  consentId: string;
  consentStatus: string;
}

export interface ContractFiles {
  documentumId: string;
  name: string;
  document: string;
  fileType: string;
  fileSize: string;
}

export interface ContractDetails {
  status: string;
  message: string;
  contractFiles: ContractFiles[];
}

export interface GetContractApiResponse extends ContractDetails {
  content: string;
}

export interface ContractState {
  contractDetails: ContractDetails
  consentDetails: ConsentDetails
  applicationNumber: string
  aem: ContractAEM
  apiEndpoints: ContractEndpoints
  createContractApiStatus: ApiStatus
  acceptContractApiStatus: ApiStatus
}
